var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"erro"},[_c('h1',[_vm._v("Acesso Negado")]),_c('p',[_vm._v("Você não tem permissão para acessar esta página.")])])
}]

export { render, staticRenderFns }